import React, { useEffect, useState, useContext } from 'react';
import axios from "axios";

import '../../css/sismo_sentido.css';
import Contexto from '../comun/Contexto';

export default function SelectorSismosGrande(props) {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /* Estado */
    const [indiceSeleccionado, setIndiceSeleccionado] = useState(null);
    const [sismos, setSismos] = useState([]);
    
    const campos = ["ID", "fecha", "latitud", "longitud", "magnitud", "I_MAX", "TOTAL_CONTEO_REPORTES", "sitio"];

    /* Efectos */
    useEffect(() => {       
        const traerSismos = async () => {
            const res = await axios(urlBaseRest+"resumen_sismos_con_intensidad/50");
            console.log(res.data)
            setSismos(res.data);
        };
        traerSismos();                
    }, []);

    /* Modificacion de estado */
    const seleccionarSismo = (index) => {
        setIndiceSeleccionado(index);
        props.setIdSismo(sismos[index].ID)
    }

    /* Render */
    return (        
        <div className="SelectorGrandeContenedor">	
        <table id="tablaSismos" >
			<thead>
				<tr>
                    <th className="SelectorEncabezadoTabla">ID</th>
					<th className="SelectorEncabezadoTabla">FECHA Y HORA</th>
                    <th className="SelectorEncabezadoTabla">LATITUD</th>
                    <th className="SelectorEncabezadoTabla">LONGITUD</th>
                    <th className="SelectorEncabezadoTabla">MAGNITUD</th>
                    <th className="SelectorEncabezadoTabla">INTENSIDAD MAXIMA</th>
                    <th className="SelectorEncabezadoTabla">REPORTES</th>
                    <th className="SelectorEncabezadoTabla">EPICENTRO</th>
				</tr>
			</thead>
			<tbody>
                {
                sismos.map((sismo, index) => {                  
                    return (
                        <tr
                        className={index===indiceSeleccionado ? "SelectorFilaSeleccionada" : "SelectorFilaNoSeleccionada"}
                        onClick={()=>{seleccionarSismo(index)}
                        }
                        key={index}>  
                            {campos.map((campo, index2)=> {
                                return (
                                    <td 
                                    key={index2}>{sismo[campo]}</td>
                                );
                            })}                            
                        </tr>
                    );
                })
                }
            </tbody>
		</table>
        </div>
    );
}